const AVAILABLE = "#F1FF7D";
const SOLD = "#707070";
const LOCKED = "#808080";
const PROCESSING = "#B5754B";
const COMMON = "#DBDBDB";
const UNCOMMON = "#DD00FF";
const RARE = "#00FF00";
const SPECIAL = "#FF0000";
const LEGENDARY = "#00D3FF";
const MYTHICAL = "#006fff";
const STORKE_COLOR = "#302f1f";
const FILL_COLOR = "#00000000";
const RESERVE = "#808080";
const Decp_Key_dev_2 = "Ra0OG3AnU3Yh";
const Decp_Key_Prod_2 = "1mpLvzpSSyMKBMkp7qKyK10D6Jti6XAVaioydHcLySzoKS0wtsAg";
export {
  AVAILABLE,
  RESERVE,
  SOLD,
  LOCKED,
  PROCESSING,
  COMMON,
  UNCOMMON,
  RARE,
  SPECIAL,
  LEGENDARY,
  MYTHICAL,
  STORKE_COLOR,
  FILL_COLOR,
  Decp_Key_dev_2,
  Decp_Key_Prod_2
};
